import type { CompanyProfile, DailyReview, SpaceEvent, SpaceNews } from '../types'

export const previewNotice = '数据说明：资讯、事件与公司档案来自已审核来源；免费公开行情可能延时或中断，仅供资讯参考，持牌数据上线后将自动优先。'

export const newsItems: Array<Omit<SpaceNews, 'storyType' | 'sourceTierCode' | 'imageUrl' | 'confidence' | 'qualityScore' | 'ai' | 'aiInsights'>> = [
  {
    id: 'n1',
    title: '低轨卫星直连手机服务进入运营商联合验证阶段',
    summary: '多家运营商正在验证普通终端与低轨卫星网络的连接能力，商业模式从技术验证转向覆盖与容量评估。',
    importance: '直连手机可能扩大卫星通信的消费级入口，但频谱、容量和终端功耗仍是关键约束。',
    source: '公司公告样例', sourceTier: '官方', topic: '卫星互联网', region: '美国', publishedAt: '07-15 09:15',
    companyIds: ['asts'], sourceUrl: 'https://investors.ast-science.com/',
  },
  {
    id: 'n2',
    title: '商业小卫星平台加速向批量化与模块化交付演进',
    summary: '卫星平台厂商持续扩大标准化部件和总装能力，以适应星座客户的批次采购与快速部署。',
    importance: '交付节奏和供应链标准化会直接影响星座建设成本与组网速度。',
    source: '交易所披露样例', sourceTier: '官方', topic: '卫星制造', region: '中国', publishedAt: '07-15 08:40',
    companyIds: ['600118', 'rdw'], sourceUrl: 'https://www.sse.com.cn/',
  },
  {
    id: 'n3',
    title: '新一代商业运载火箭将复用能力与任务响应速度并列为核心指标',
    summary: '发射服务商正在同时推进发动机、结构、回收和任务集成能力，竞争焦点从单次运力扩展到交付节奏。',
    importance: '可靠性和年发射频次比单次宣传运力更能决定商业发射的实际供给。',
    source: '企业官网样例', sourceTier: '官方', topic: '运载火箭', region: '全球', publishedAt: '07-15 08:05',
    companyIds: ['rklb'], eventId: 'e1', sourceUrl: 'https://www.rocketlabusa.com/',
  },
  {
    id: 'n4',
    title: '遥感卫星公司把竞争重点转向高频重访与自动分析',
    summary: '地球观测企业正将卫星影像、任务调度和 AI 分析打包为持续服务，而不是单次销售影像。',
    importance: '数据到决策的时间缩短，将决定商业遥感能否扩大到日常运营场景。',
    source: '公司更新样例', sourceTier: '官方', topic: '遥感', region: '全球', publishedAt: '07-14 21:30',
    companyIds: ['pl', 'bksy'], sourceUrl: 'https://www.planet.com/',
  },
  {
    id: 'n5',
    title: '卫星互联网地面系统进入芯片、终端与信关站协同阶段',
    summary: '国内产业链公司持续推进卫星通信芯片、终端和地面网络的系统级适配。',
    importance: '地面侧成熟度决定星座能力能否形成可规模交付的用户服务。',
    source: '深交所披露样例', sourceTier: '官方', topic: '地面设备', region: '中国', publishedAt: '07-14 18:10',
    companyIds: ['300045', '002465'], sourceUrl: 'https://www.szse.cn/',
  },
  {
    id: 'n6',
    title: '月球商业服务从单次着陆转向通信、导航与载荷交付组合',
    summary: '商业月球公司开始构建着陆器、数据中继和载荷交付的连续任务能力。',
    importance: '可重复的基础设施服务比单次任务更接近可持续商业模式。',
    source: '公司公告样例', sourceTier: '官方', topic: '月球与深空', region: '美国', publishedAt: '07-14 15:45',
    companyIds: ['lunr'], sourceUrl: 'https://investors.intuitivemachines.com/',
  },
]

export const events: SpaceEvent[] = [
  { id: 'e1', title: 'Neutron 首飞窗口', organization: 'Rocket Lab', dateLabel: 'NET 2026 H2', isoDate: '2026-10-01', precision: 'quarter', status: 'net', location: '待官方确认', summary: '中型可复用运载火箭首飞窗口；页面将通过官方更新保留每次窗口修订。', sourceUrl: 'https://www.rocketlabusa.com/launch/neutron/', source: 'Rocket Lab' },
  { id: 'e2', title: 'BlueBird 后续批次部署', organization: 'AST SpaceMobile', dateLabel: '2026 下半年', isoDate: '2026-11-01', precision: 'quarter', status: 'tentative', location: '待官方确认', summary: '直连手机星座后续部署计划，具体批次与发射时间需以公司和发射方为准。', sourceUrl: 'https://investors.ast-science.com/', source: 'AST SpaceMobile' },
  { id: 'e3', title: '国内低轨通信星座组网任务', organization: '任务方待接入', dateLabel: '未来 30 天', isoDate: '2026-08-12', precision: 'month', status: 'tentative', location: '中国', summary: '演示事件：生产环境接入任务方和 Launch Library 后展示精确批次与窗口。', sourceUrl: 'https://www.cnsa.gov.cn/', source: '国家航天局' },
  { id: 'e7', title: '商业遥感卫星发射窗口（演示）', organization: '任务方待接入', dateLabel: '07-18 · 演示', isoDate: '2026-07-18', precision: 'day', status: 'tentative', location: '待官方确认', summary: '用于验证七日事件轨道的演示记录；生产环境必须由任务官方或 Launch Library 动态替换。', sourceUrl: 'https://lldev.thespacedevs.com/', source: 'Launch Library 2' },
  { id: 'e4', title: 'Falcon 1 首次成功入轨', organization: 'SpaceX', dateLabel: '2008-09-28', isoDate: '2008-09-28', precision: 'day', status: 'completed', location: '马绍尔群岛', summary: '首枚由私人开发的液体燃料运载火箭成功进入地球轨道，是商业发射的重要历史节点。', sourceUrl: 'https://www.spacex.com/', source: 'SpaceX' },
  { id: 'e5', title: 'Crew Dragon 首次载人飞行', organization: 'NASA / SpaceX', dateLabel: '2020-05-30', isoDate: '2020-05-30', precision: 'day', status: 'completed', location: '肯尼迪航天中心', summary: '商业载人航天器首次将宇航员送入轨道并前往国际空间站。', sourceUrl: 'https://www.nasa.gov/mission/demo-2/', source: 'NASA' },
  { id: 'e6', title: 'Odysseus 月球着陆', organization: 'Intuitive Machines', dateLabel: '2024-02-22', isoDate: '2024-02-22', precision: 'day', status: 'completed', location: '月球南极区域', summary: '商业公司研制的月球着陆器完成着陆，为商业月球服务提供任务验证。', sourceUrl: 'https://www.nasa.gov/mission/clps/', source: 'NASA CLPS' },
]

export const companies: CompanyProfile[] = [
  { id: 'rklb', name: 'Rocket Lab', nameEn: 'Rocket Lab Corporation', country: '美国 / 新西兰', type: '发射与航天系统', founded: '2006', status: '运营中', themes: ['运载火箭', '卫星平台', '航天器部件'], summary: '覆盖小型发射、卫星平台、部件与在轨任务支持的端到端航天公司。', website: 'https://www.rocketlabusa.com/', instrumentIds: ['rklb'] },
  { id: 'asts', name: 'AST SpaceMobile', nameEn: 'AST SpaceMobile, Inc.', country: '美国', type: '卫星互联网', founded: '2017', status: '运营中', themes: ['直连手机', '低轨星座'], summary: '建设面向普通移动终端的低轨卫星宽带网络。', website: 'https://ast-science.com/', instrumentIds: ['asts'] },
  { id: 'lunr', name: '直觉机器', nameEn: 'Intuitive Machines, Inc.', country: '美国', type: '月球服务', founded: '2013', status: '运营中', themes: ['月球着陆', '深空通信'], summary: '提供月球载荷交付、数据服务与深空基础设施。', website: 'https://www.intuitivemachines.com/', instrumentIds: ['lunr'] },
  { id: 'rdw', name: 'Redwire', nameEn: 'Redwire Corporation', country: '美国', type: '空间基础设施', founded: '2020', status: '运营中', themes: ['卫星部件', '在轨制造'], summary: '提供航天器关键部件、数字工程和微重力制造能力。', website: 'https://redwirespace.com/', instrumentIds: ['rdw'] },
  { id: '600118', name: '中国卫星', nameEn: 'China Spacesat Co., Ltd.', country: '中国', type: '卫星制造与应用', founded: '1997', status: '运营中', themes: ['小卫星', '卫星应用'], summary: '覆盖小卫星研制、卫星应用系统与相关服务。', website: 'https://www.sse.com.cn/', instrumentIds: ['600118'] },
  { id: '601698', name: '中国卫通', nameEn: 'China Satellite Communications Co., Ltd.', country: '中国', type: '卫星运营', founded: '2001', status: '运营中', themes: ['通信卫星', '卫星运营'], summary: '提供通信广播卫星运营与卫星通信服务。', website: 'https://www.chinasatcom.com/', instrumentIds: ['601698'] },
  { id: '688568', name: '中科星图', nameEn: 'Geovis Technology Co., Ltd.', country: '中国', type: '空天信息', founded: '2006', status: '运营中', themes: ['数字地球', '遥感数据'], summary: '以数字地球产品为核心提供空天信息数据、计算和应用服务。', website: 'https://www.geovis.com.cn/', instrumentIds: ['688568'] },
  { id: '01045', name: '亚太卫星', nameEn: 'APT Satellite Holdings Limited', country: '中国香港', type: '卫星运营', founded: '1992', status: '运营中', themes: ['通信卫星', '转发器服务'], summary: '运营通信卫星并提供广播、电信和数据服务。', website: 'https://www.apstar.com/', instrumentIds: ['01045'] },
]

export const dailyReview: DailyReview = {
  status: 'passed',
  reviewedAt: '2026-07-15 07:42 Asia/Shanghai',
  model: '共享 AI Gateway / reviewer',
  promptVersion: 'space-daily-review-v1',
  score: 94,
  checks: [
    { label: '事实与来源覆盖', passed: true, detail: '关键事实均绑定来源或标记为待验证' },
    { label: '数字一致性', passed: true, detail: '行情数值由程序提供，正文未自行计算' },
    { label: '重复与聚类', passed: true, detail: '同一事件已合并，未跨栏目重复占位' },
    { label: '不确定性表达', passed: true, detail: '未来窗口使用 NET / tentative' },
    { label: '市场合规', passed: true, detail: '无目标价、收益承诺或买卖指令' },
  ],
}

export const communityPosts = [
  { id: 'p1', title: '如何判断一家公司是真正的商业航天公司？', author: '轨道研究员', tag: '产业研究', replies: 18, updatedAt: '32 分钟前', excerpt: '我更倾向于看收入暴露、产品是否在轨验证，以及客户是否来自可持续商业需求。' },
  { id: 'p2', title: '事件时间被多次推迟时，数据库应该怎么表达？', author: 'Launch Window', tag: '数据纠错', replies: 9, updatedAt: '1 小时前', excerpt: '建议保留窗口修订历史，而不是直接覆盖原日期，否则很难判断信息源可靠性。' },
  { id: 'p3', title: '卫星直连手机会先在哪些场景形成收入？', author: '星间链路', tag: '技术讨论', replies: 26, updatedAt: '3 小时前', excerpt: '偏远地区补盲、应急和低速消息可能比大带宽消费场景更早落地。' },
  { id: 'p4', title: '中国商业航天供应链股票池纳入标准建议', author: '北纬 40°', tag: '市场讨论', replies: 14, updatedAt: '昨天', excerpt: '名称里带航天并不够，最好要求年报中出现明确产品、客户或收入证据。' },
]
